import { formatRupiah } from "@/helpers/utils";
import ApiService from '@/services/api';
import Swal from "sweetalert2";

const getStatusBadge = (status) => {
  const badges = {
    process: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    completed: 'bg-green-100 text-green-800 border-green-300',
    cancelled: 'bg-red-100 text-red-800 border-red-300',
    pending: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

export const tableColumnsMember = [
  { title: 'Member', queryKey: 'full_name' },
  { 
    title: 'Registration Date', 
    queryKey: 'join_date',
    component: (item) => (
      <span>
        {item.join_date ? new Date(item.join_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  { title: 'Contact', queryKey: 'phone_number' },
  { title: 'Status', queryKey: 'status' },
];

export const columnsHistory = [
  {
    title: 'Tanggal Setor',
    queryKey: 'transaction_date',
    component: (item) => (
      <span>
        {item.transaction_date ? new Date(item.transaction_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  { 
    title: 'Kode Transaksi', queryKey: 'transaction_number'
  },
  {
    title: 'Detail Pembayaran',
    queryKey: 'bank_account_name',
    component: (item) => (
      <span>
        {item.payment_details.bank_name} - {item.payment_details.bank_account_name} ({item.payment_details.bank_account_number})
      </span>
    )
  },
  {
    title: 'Jumlah',
    queryKey: 'amount',
    component: (item) => (
      <span>
        {formatRupiah(item.amount)}
      </span>
    )
  },
  {
    title: 'Status',
    queryKey: 'status',
    component: (item) => (
      <span className={`text-gray-900 px-3 py-1 text-sm font-semibold rounded-md border ${getStatusBadge(item.status)}`}>
        {item.status}
      </span>
    )
  },
];

export const actionHistory = (row) => {
  const handleClick = async (action) => {
    try {
      const response = await ApiService.approvalTransaction(row.id, action);
      if (response === 201) {
        Swal.fire({
          icon: 'success',
          title: 'Sukses!',
          text: 'Transaction Approval Success!',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed Action',
      });
    }
  };

  return (
    <>
      {(row.status !== "completed" && row.status !== "cancelled") && (
        <div className="flex gap-3">
          <button
            className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
            onClick={() => handleClick('approved')}
          >
            <i className='mgc_check_line'></i>
          </button>
          <button
            className='rounded-md bg-red-400 hover:bg-red-500 text-white py-1 p-2'
            onClick={() => handleClick('cancel')}
          >
            <i className='mgc_close_line'></i>
          </button>
        </div>
      )}
    </>
  )
}

export const renderActionMember = (row, onClose, navigate) => {
  const handleClick = () => {
    navigate(`/admin/loan-application?id=${row.id}`);
    onClose();
  };
  return (
    <button
      className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
      onClick={handleClick}
    >
      <i className='mgc_check_line'></i>
    </button>
  )
}